import React from 'react';
import { useSelector } from 'react-redux';
import { PRODUCT_PLANS_PAGE_URL } from '../../../FreemiumNurtureBar/nurture-content';
import styles from './styles.module.css';
import { isUserAnOwner } from '../../../../redux/fe-data/selectors';


const showCallToAction = () => {
  const isAccountOwner = useSelector(isUserAnOwner);
  if (isAccountOwner) {
    return (
      <span>
        <a href={PRODUCT_PLANS_PAGE_URL}>
          Upgrade Now to continue using PagerDuty
        </a>
      </span>
    );
  }
  return (
    <span>
      &nbsp;Contact your account admin to reactivate your account.
    </span>
  );
};

export default function ExpiredNotification() {
  return (
    <div className={styles.expiredNotification}>
      <span>
        Your account has expired.
      </span>
      {
        showCallToAction()
      }
    </div>
  );
}
